var ClientTable = require('./lib/v-client-table');
var ServerTable = require('./lib/v-server-table');
var Event = require('./lib/bus');

module.exports = {
  ClientTable,
  ServerTable,
  Event
};



// WEBPACK FOOTER //
// ./~/vue-tables-2/index.js